(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
